const protocolLanguageSelect = document.querySelector('.protocol-language-select');
protocolLanguageSelect && protocolLanguageSelect.addEventListener('change', (event) => {
    document.querySelector('.protocol-link--complete').href = event.target.value;
});
